export function Home({ ...rest }) {
  return (
    <svg {...rest} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.5 17.4167H8.25V11.9167H13.75V17.4167H16.5V9.16667L11 5.04167L5.5 9.16667V17.4167ZM3.66667 19.25V8.25L11 2.75L18.3333 8.25V19.25H11.9167V13.75H10.0833V19.25H3.66667Z"
        fill="#666666"
      />
    </svg>
  );
}
